import { render } from "./TopicCell.vue?vue&type=template&id=230a93fa&scoped=true"
import script from "./TopicCell.vue?vue&type=script&lang=js"
export * from "./TopicCell.vue?vue&type=script&lang=js"

import "./TopicCell.vue?vue&type=style&index=0&id=230a93fa&lang=scss&scoped=true"

import exportComponent from "/opt/homebrew/var/www/zsplus_channel/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-230a93fa"]])

export default __exports__